<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>{{$t('推广码')}}</div>
		<div></div>
	</header>
	<div class="z-body recharge-body" style="height: 100%;bottom:0px;">

		<div class="z-flex" style="flex-direction:column;">
			<div style="padding:15px;color:#fff">{{$t('推广')}}</div>
			<div><img :src="data.qrcode" style="width:100px;height:100px;"></div>
			<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doSaveImg(data.qrcode)">{{$t('存为图片')}}</div>
		</div>
		<div class="z-flex" style="flex-direction:column;">
			<!-- <div style="padding:15px 0;" v-text="data.code"></div> -->
			<div style="padding:15px;color:#FA5E00;width:80%;text-align:center;" @click="doCopy(data.code)">{{$t('复制推广链接')}}</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	name: 'share',
	data() {
		return {
			data:{
				code:'',
				qrcode:'',
			},
		}
	},
	mounted() {
	},
	created() {
		this.data = {
			code:this.$route.query.link,
			qrcode:this.$route.query.qrcode,
		}
	},
	methods: {
		doSaveImg:function (url) {
			let a = document.createElement('a');
              a.download = this.$t('推广码')
              a.href = url;
              a.click();
		},
		doCopy:function(value){
			let _input = document.createElement("input");   // 直接构建input
			_input.value = value;  // 设置内容
			document.body.appendChild(_input);    // 添加临时实例
			_input.select();   // 选择实例内容
			document.execCommand("Copy");   // 执行复制
			document.body.removeChild(_input); // 删除临时实例
            this.$store.commit('layer',this.$t('复制成功'))
		},
	}
}
</script>
<style scoped>
.recharge-tips {
	font-size: 16px;
	padding: 10px;
}
.recharge-tips p{
	margin-bottom: 10px;
}
.recharge-row {
	height:50px;
	justify-content:space-between;
	border-bottom: 1px solid #F5F5F5;
	padding:0 10px;
}

</style>



// WEBPACK FOOTER //
// src/pages/my/share.vue